export const socialData = [
  {
    id: 1,
    site: "GitHub",
    src: "https://github.com/mjshelton12",
    img: "https://i.imgur.com/RQf6YHc.jpg",
    alt: "GitHub Logo",
    target: "blank",
  },
  {
    id: 2,
    site: "LinkedIn",
    src: "https://www.linkedin.com/in/michelle-mj-shelton-80690341/",
    img: "https://i.imgur.com/TU5J0b4.jpg",
    alt: "LinkedIn Logo",
    target: "blank",
  },
  {
    id: 3,
    site: "Email",
    src: "mailto:inquiries.mjshelton@gmail.com",
    img: "https://imgur.com/y9pUlMt.jpg",
    alt: "Email Logo",
  },
];
